import { Component } from '@angular/core';
import { FiltersSeriesTeamsService } from '../filters-series-teams.service';

@Component({
  selector: 'app-filters-series-teams',
  templateUrl: './filters-series-teams.component.html',
  styleUrls: ['./filters-series-teams.component.css']
})
export class FiltersSeriesTeamsComponent {
  constructor(
    public filter_service: FiltersSeriesTeamsService
  ) {
  }
}
